import axios from 'axios';
axios.defaults.timeout = 10000;

/**
 * Fetch a list of events
 */
const listAllEvents = async () => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const events = await axios
    .get(`${apiUrl}/v1/public/events`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  console.log("Events: ", events);

  return events;
};

const showEvent = async (id) => {
  const apiUrl = process.env.VUE_APP_API_URL;
  const event = await axios
    .get(`${apiUrl}/v1/public/events/${id}`)
    .then((response) => {
      return {
        status: response.status,
        data: response.data.data,
      };
    });
  console.log("Event: ", event);

  return event;
};

export default {
  listAllEvents,
  showEvent,
};
